// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notified-users {\r\n  position: relative;\r\n}\r\n\r\n.notified-users h6 {\r\n  margin: 20px 0;\r\n  color: var(--primary-font-color);\r\n}\r\n\r\n.notified-users .users-list {\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n  color: var(--primary-style-color);\r\n}\r\n", ""]);
// Exports
module.exports = exports;
